import Badge from "glesys-controlpanel/components/badge";
import { t } from "ember-intl";
import BadgeBrand from "glesys-controlpanel/components/badge/brand";

<template>
  <span class="flex items-center gap-3 px-4 py-3 sm:gap-4 sm:px-6 sm:py-4">
    <span class="flex-1 min-w-0 flex items-center gap-4" data-test-entity-identity>
      <span class="flex items-baseline gap-2 min-w-0 text-base">
        <span class="truncate text-black" data-test-entity-title title={{@title}}>{{@title}}</span>
        {{#if @key}}
          <span class="shrink-0 text-gray-500 group-hover:text-black" data-test-entity-key>{{@key}}</span>
        {{/if}}
      </span>
      {{#if @workflowState}}
        <Badge
          class="shrink-0"
          data-test-entity-workflow-state
          @color={{@workflowState.color}}
          @text={{@workflowState.label}}
        />
      {{/if}}
      {{#if @managedHosting}}
        <BadgeBrand class="shrink-0" data-test-entity-managed-hosting @text={{t "component.managed-hosting"}} />
      {{/if}}
    </span>
    <span class="flex items-center gap-2 shrink-0">
      {{yield}}
    </span>
  </span>
</template>
